// extracted by mini-css-extract-plugin
export default {"detailContainer":"detail_detailContainer__-QTZ+","leftSection":"detail_leftSection__S5-Di","rightSection":"detail_rightSection__fGpaT"};